<script setup lang="ts">
import { watch, ref } from 'vue';
import { useRoute } from 'vue-router';

import { SETTINGS_ROUTES } from '@/modules/settings/utils/constants/routes';

const route = useRoute();
const routes = ['MailboxesSettings', 'UsersSettings', 'TeamsSettings', 'BusinessSettings', 'MetricAdjustments', 'ContactGroupsSettings'];
const tabs = ref([
    { name: 'Mailboxes', href: SETTINGS_ROUTES.MailboxesSettings, current: false },
    { name: 'Users', href: SETTINGS_ROUTES.UsersSettings, current: false },
    { name: 'Teams', href: SETTINGS_ROUTES.TeamsSettings, current: false },
    { name: 'Business Hours', href: SETTINGS_ROUTES.BusinessSettings, current: false },
    { name: 'Metric Adjustments', href: SETTINGS_ROUTES.MetricAdjustments, current: false },
    { name: 'Contact Groups', href: SETTINGS_ROUTES.ContactGroupsSettings, current: false }
]);

watch(
    route,
    (newVal) => {
        routes.forEach((settingRoute: string, index: number) => {
            if (
                newVal.name ===
                SETTINGS_ROUTES[settingRoute as 'MailboxesSettings' | 'AddMailboxesSettings' | 'UsersSettings' | 'TeamsSettings' | 'MetricAdjustments' | 'BusinessSettings' | 'ContactGroupsSettings']
            )
                tabs.value[index].current = true;
            else tabs.value[index].current = false;
        });
    },
    { immediate: true }
);
</script>

<template>
    <div class="max-w-[1120px] w-full h-full">
        <div v-if="!route.path.includes('add')">
            <p class="text-gray-800 text-3xl font-bold leading-9">Settings</p>
            <div class="border-b border-gray-200 w-fit">
                <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                    <router-link
                        v-for="tab in tabs"
                        :key="tab.name"
                        :to="{ name: tab.href }"
                        :class="[
                            tab.current ? 'border-indigo-500 text-indigo-500' : 'border-transparent transition duration-0 hover:duration-200 text-gray-500 hover:text-gray-700 hover:border-gray-300',
                            'whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm'
                        ]"
                        >{{ tab.name }}</router-link
                    >
                </nav>
            </div>
        </div>
        <RouterView />
    </div>
</template>
